import _ from 'lodash';
import { createSelector } from 'reselect';
import { getVideoIds } from '../../../../widget/redux/client/lazy-channel-videos/selectors';
export var isSingleVideoView = createSelector([getVideoIds], function (videoIds) { return _.size(videoIds) === 1; });
